const animation = require("./timerEnd.json");

module.exports = {
    loop: false,
    autoplay: true,
    animationData: animation,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid'
    },
}